// extracted by mini-css-extract-plugin
export default {"tooltip":"Eo-z","sharingV2":"Fo-z","sharingIconsV2":"Go-z","links":"Ho-z","link":"Io-z","facebookV2":"Jo-z","twitterV2":"Ko-z","pinterestV2":"Lo-z"};